import React from "react";
import { Container, Section } from "./layout";

export default function StatSection({ stats }) {
  return (
    <Section extraClasses="bg-dark">
      <Container extraClasses="flex flex-col md:flex-row justify-around">
        {stats.map((stat, idx) => {
          return <Stat key={idx} stat={stat} />;
        })}
      </Container>
    </Section>
  );
}

function Stat({ stat }) {
  return (
    <div className="text-center m-2">
      <h3 className="text-2xl uppercase font-bold text-red">{stat.figure}</h3>
      <p className="text-base text-white">{stat.caption}</p>
    </div>
  );
}
